var _dec, _dec2, _class;
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { disposeInstance } from 'zova';
import { Behavior } from '../lib/behavior.js';
import { BeanBehaviorBase } from './bean.behaviorBase.js';
export let BehaviorRoot = (_dec = Behavior(), _dec2 = __z_BeanInfo({
  module: "a-behavior"
}), _dec(_class = _dec2(_class = class BehaviorRoot extends BeanBehaviorBase {
  constructor(...args) {
    super(...args);
    this.composer = void 0;
  }
  async __init__(options) {
    this.composer = await this.createComposer(options.behaviors);
  }
  __dispose__() {
    disposeInstance(this.composer);
  }
  async onOptionsChange(options) {
    await super.onOptionsChange(options);
    await this.composer.load(options.behaviors);
  }
  render(props, next) {
    return this.composer.render(props, next);
  }
}) || _class) || _class);